export enum ZoomType {
    horizontal = 'x',
    vertical = 'y',
}

export interface ZoomParams {
    readonly type?: ZoomType;
    readonly scale: number;
}
